import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Button } from 'semantic-ui-react';
import { withRouter } from 'react-router';
import ReactTable from 'react-table';
import moment from 'moment';

import { Filter, Main } from 'Containers';
import { getImportResults } from './state/resultgrid/actions';
import { caseInsensitiveFilter } from 'Common/GridHelper';

class ImportResultContainer extends Component {
  getMainProps = () => {
    return {
      toolbox: {
        shown: true,
      },
    };
  };

  componentDidMount() {
    this.props.getImportResults();
  }

  columns = [
    {
      Header: 'Id',
      accessor: 'Id',
    },
    {
      Header: 'User',
      accessor: 'UserName',
    },
    {
      Header: 'Import Type',
      accessor: 'ImportType',
    },
    {
      Header: 'Start Date',
      id: 'StartDate',
      accessor: row => moment(row.StartDT).format('MM/DD/YYYY h:mm:ss A'),
    },
    {
      Header: 'End Date',
      id: 'EndDate',
      accessor: row =>
        row.EndDT ? moment(row.EndDT).format('MM/DD/YYYY h:mm:ss A') : null,
    },
    {
      Header: 'Import Outcome',
      accessor: 'ImportOutcome.Description',
    },
    {
      Cell: ({ row }) => (
        <Button onClick={this.viewResult(row.Id)} size="mini">
          View
        </Button>
      ),
      className: 'lite-padding',
      width: 62,
      filterable: false,
      sortable: false,
    },
  ];

  viewResult = id => () => {
    this.props.history.push(`/importresult/${id}`);
  };

  render() {
    return (
      <Fragment>
        <Filter title={'Import Results'} />
        <Main {...this.getMainProps()}>
          <ReactTable
            className={'grid--fixed-row-height'}
            minRows={10}
            defaultPageSize={10}
            showPageSizeOptions={false}
            data={this.props.importResults}
            columns={this.columns}
            loading={this.props.fetching}
            filterable
            defaultFilterMethod={caseInsensitiveFilter}
            defaultSorted={[
              {
                id: 'Id',
                desc: true,
              },
            ]}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    importResults: state.ImportResultState.resultGrid.importResults,
    fetching: state.ImportResultState.resultGrid.fetching,
  };
};

export const ImportResult = withRouter(
  connect(
    mapStateToProps,
    { getImportResults }
  )(ImportResultContainer)
);



// WEBPACK FOOTER //
// ./src/pages/importresult/ImportResult.js